import ContentSections from "../../ContentSections/ContentSections";

// Fallback enquanto o backend nao retorna nada.
const FALLBACK = {
  title: "Ciclos de Aprendizagem",
  text: "",
};

// Schema real (models/Metodologia.js): cycles e um textSectionSchema unico
// ({ title, text }), assim como peads.
export default function Cycles({ section, isEditing, onChange }) {
  if (isEditing) {
    const value = section ?? FALLBACK;

    return (
      <div className="metodologia-page__bloco">
        <input
          className="metodologia-page__campo"
          value={value.title || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />
        <textarea
          className="metodologia-page__campo"
          value={value.text || ""}
          onChange={(e) => onChange("text", e.target.value)}
        />
      </div>
    );
  }

  const value = section ?? FALLBACK;

  return (
    <ContentSections sections={[{ title: value.title, text: value.text }]} />
  );
}
